import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import dynamic from "next/dynamic";
import { Menu, Search } from "react-feather";
import { motion, AnimatePresence } from "framer-motion";
import UserSection from "./UserSection";
import { MobileHeaderProps } from "./types";
import tooffiLogo from "@/assets/images/tooffi-logo.svg";
import ImageComponent from "@/components/ui/image";
import { ShoppingBag } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCheckout } from "@/contexts/checkout";
import { useCallback, useMemo } from "react";
const ProductSearch = dynamic(() => import("@/components/product/search"), {
  ssr: false,
  loading: () => null
});
const MobileHeader: React.FC<MobileHeaderProps> = t0 => {
  const $ = _c(40);
  const {
    isAppLaunched,
    showSearch,
    showSearchVisible,
    showCart,
    setShowSearch,
    setShowLoginState,
    isAuthenticated,
    isAuthLoading,
    showUser,
    showUserDropdown,
    setShowUserDropdown,
    handleLogout,
    isLoggingOut,
    userDropdownRef,
    setSidebarOpen,
    showNavLinks: t1,
    mounted
  } = t0;
  const showNavLinks = t1 === undefined ? true : t1;
  const {
    products,
    setIsCartOpen
  } = useCheckout();
  const cartItemCount = products.reduce(_temp, 0);
  let t2;
  if ($[0] !== setIsCartOpen) {
    t2 = () => {
      setIsCartOpen(true);
    };
    $[0] = setIsCartOpen;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const openCart = t2;
  const t3 = isAppLaunched ? "flex pb-4 bg-white flex-col pt-3" : "";
  const t4 = `flex items-center ${isAppLaunched ? "justify-between" : "justify-center"} px-2  lg:hidden pointer-events-auto lg:pointer-events-none`;
  let t5;
  if ($[2] !== isAppLaunched || $[3] !== setSidebarOpen || $[4] !== showNavLinks) {
    t5 = isAppLaunched && showNavLinks && <button className="text-center items-center rounded-full mr-4 pl-1 touch-manipulation" onClick={() => setSidebarOpen(true)}><Menu className="text-[#777777]" size={24} /></button>;
    $[2] = isAppLaunched;
    $[3] = setSidebarOpen;
    $[4] = showNavLinks;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex flex-row items-center"><Link href="/" className="font-medium text-lg font-montserrat text-[#5A5A5A] py-2"><ImageComponent alt="tooffi" src={tooffiLogo} className="h-9 lg:h-14 w-auto aspect-[124/47]" width={124} height={47} sizes="(max-width: 1024px) 95px, 148px" objectFit="contain" preload={true} /></Link></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5) {
    t7 = <div className="flex items-center">{t5}{t6}</div>;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== cartItemCount || $[10] !== handleLogout || $[11] !== isAppLaunched || $[12] !== isAuthLoading || $[13] !== isAuthenticated || $[14] !== isLoggingOut || $[15] !== mounted || $[16] !== openCart || $[17] !== setShowLoginState || $[18] !== setShowSearch || $[19] !== setShowUserDropdown || $[20] !== showCart || $[21] !== showSearch || $[22] !== showSearchVisible || $[23] !== showUser || $[24] !== showUserDropdown || $[25] !== userDropdownRef) {
    t8 = isAppLaunched && <div className="flex items-center ">{showSearchVisible && <button className="border rounded-full border-[#D9D9D9] p-[6px]" onClick={() => setShowSearch(!showSearch)}><Search className="text-[#777777] w-3 h-3" /></button>}{showCart && <Button className="relative cursor-pointer" onClick={openCart} variant="ghost"><ShoppingBag size={24} />{mounted && cartItemCount > 0 && <div className="absolute -top-[1px] right-2 bg-[#037A6A] text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">{cartItemCount}</div>}</Button>}{mounted ? <UserSection isAuthenticated={isAuthenticated} isAuthLoading={isAuthLoading} showUser={showUser} showUserDropdown={showUserDropdown} setShowUserDropdown={setShowUserDropdown} handleLogout={handleLogout} isLoggingOut={isLoggingOut} userDropdownRef={userDropdownRef} setShowLoginState={setShowLoginState} /> : <div className="w-8 h-8 rounded-full bg-gray-100" />}</div>;
    $[9] = cartItemCount;
    $[10] = handleLogout;
    $[11] = isAppLaunched;
    $[12] = isAuthLoading;
    $[13] = isAuthenticated;
    $[14] = isLoggingOut;
    $[15] = mounted;
    $[16] = openCart;
    $[17] = setShowLoginState;
    $[18] = setShowSearch;
    $[19] = setShowUserDropdown;
    $[20] = showCart;
    $[21] = showSearch;
    $[22] = showSearchVisible;
    $[23] = showUser;
    $[24] = showUserDropdown;
    $[25] = userDropdownRef;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t4 || $[28] !== t7 || $[29] !== t8) {
    t9 = <div className={t4}>{t7}{t8}</div>;
    $[27] = t4;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== setShowSearch || $[32] !== showSearch) {
    t10 = showSearch && <motion.div initial={{
      opacity: 0,
      y: -8
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -8
    }} transition={{
      duration: 0.2,
      ease: "easeInOut"
    }} className="bg-white"><div className="px-2 pb-4"><ProductSearch isMobile={true} setShowSearch={setShowSearch} /></div></motion.div>;
    $[31] = setShowSearch;
    $[32] = showSearch;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== t10) {
    t11 = <AnimatePresence>{t10}</AnimatePresence>;
    $[34] = t10;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== t11 || $[37] !== t3 || $[38] !== t9) {
    t12 = <div className={t3}>{t9}{t11}</div>;
    $[36] = t11;
    $[37] = t3;
    $[38] = t9;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  return t12;
};
export default MobileHeader;
function _temp(acc, product) {
  return acc + product.count;
}